// import Vue from 'vue'
// import VueRouter from 'vue-router'
import { createRouter, createWebHashHistory } from "vue-router";

const home = () => import("../views/home/home.vue");
const community = () => import("../views/community/community.vue");
const event = () => import("../views/event/event.vue");
const expertPro = () => import("../views/expertProposal/index.vue");
const me = () => import("../views/me/index.vue");
const layout = () => import("../views/layout/layout.vue");
// const login = () => import('../views/login/index.vue')

// 解决3.1版本后在控制台出现的警告
// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push (location, onResolve, onReject) {
//   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
//   return originalPush.call(this, location).catch(err => err)
// }

// Vue.use(VueRouter)
const routes = [
  { path: "/", redirect: "/layout/home" },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/wechatIndex.vue"),
  },
    {
    path: "/userinfo",
    name: "userinfo",
    component: () => import("../views/home/userData.vue"),
  },
  {
    name: "myRegister",
    path: "/register",
    component: () => import("../views/login/register.vue"),
  },
  {
    name: "myRetrieve",
    path: "/retrieve",
    component: () => import("../views/login/retrieve.vue"),
  },
  {
    name: "matchHeader",
    path: "/matchHeader",
    component: () => import("../views/event/matchHeader.vue"),
  },
  {
    name: "disCount",
    path: "/disCount",
    component: () => import("../views/me/discount/discountCoupons.vue"),
  },
  {
    name: "schemeDetail",
    path: "/schemeDetail",
    component: () => import("../views//expertProposal/schemeDetail.vue"),
  },
  {
    name: "myOrder",
    path: "/myOrder",
    component: () => import("../views/me/myOrder/orderList.vue"),
  },
  {
    name: "expertList",
    path: "/expertList",
    component: () => import("../views/expertProposal/expertList.vue"),
  },
  {
    name: "colorOrder",
    path: "/colorOrder",
    component: () => import("../views/me/colorOrder/colorOrder.vue"),
  },
  {
    name: "orderDetail",
    path: "/orderDetail",
    component: () => import("../views/me/colorOrder/orderDetail.vue"),
  },
  {
    name: "dltCode",
    path: "/dltCode",
    component: () => import("../views/me/colorOrder/dltCode.vue"),
  },
  {
    name: "basketMatchInfo",
    path: "/basketMatchInfo",
    component: () => import("../views/event/basketMatchInfo.vue"),
  },
  {
    name: "shareImage",
    path: "/shareImage",
    component: () => import("../views/share/shareImage.vue"),
  },
  {
    name: "shareList",
    path: "/shareList",
    component: () => import("../views/share/shareList.vue"),
  },
  {
    name: "historyDraw",
    path: "/historyDraw",
    component: () => import("../views/recordInfo/historyDraw.vue"),
  },
  {
    name: "awardDetails",
    path: "/awardDetails",
    component: () => import("../views/recordInfo/awardDetails.vue"),
  },
  {
    name: "codePicture",
    path: "/codePicture",
    component: () => import("../views/recordInfo/codePicture.vue"),
  },
  {
    name: "dleCalc",
    path: "/dleCalc",
    component: () => import("../views/recordInfo/dleCalc.vue"),
  },
  {
    name: "matrixSeletchCode",
    path: "/matrixSeletchCode",
    component: () => import("../views/recordInfo/matrixSeletchCode.vue"),
  },
  {
    name: "matrixDetail",
    path: "/matrixDetail",
    component: () => import("../views/recordInfo/matrixDetail.vue"),
  },
  {
    name: "gradeComparison",
    path: "/gradeComparison",
    component: () =>
      import("../views/recordInfo/arrangeThree/gradeComparison.vue"),
  },
  {
    name: "threeHistory",
    path: "/threeHistory",
    component: () =>
      import("../views/recordInfo/arrangeThree/threeHistory.vue"),
  },
  {
    name: "threePicture",
    path: "/threePicture",
    component: () =>
      import("../views/recordInfo/arrangeThree/threePicture.vue"),
  },
  {
    name: "divideInfo",
    path: "/divideInfo",
    component: () => import("../views/recordInfo/arrangeThree/divideInfo.vue"),
  },
  {
    name: "backetballScheme",
    path: "/backetballScheme",
    component: () => import("../views/expertProposal/backetballScheme.vue"),
  },
  {
    name: "reportList",
    path: "/reportList",
    component: () => import("../views/home/matchReportList/reportList.vue"),
  },
  {
    name: "reportDetail",
    path: "/reportDetail",
    component: () => import("../views/home/matchReportList/reportDetail.vue"),
  },
  {
    name: "submitWechat",
    path: "/submitWechat",
    component: () => import("../views/expertProposal/submitWechat.vue"),
  },
  {
    name: "myFollow",
    path: "/myFollow",
    component: () => import("../views/me/follow/myFollow.vue"),
  },
  {
    name: "textWechat",
    path: "/textWechat",
    component: () => import("../views/expertProposal/textWechat.vue"),
  },
  {
    name: "profitOrder",
    path: "/profitOrder",
    component: () => import("../views/me/myOrder/profitOrder.vue"),
  },
  {
    name: "maShareUser",
    path: "/maShareUser",
    component: () => import("../views/me/myOrder/maShareUser.vue"),
  },
  {
    name: "layout",
    path: "/layout",
    component: layout,
    children: [
      { name: "home", path: "home", component: home },
      { name: "community", path: "community", component: community },
      { name: "event", path: "event", component: event },
      { name: "expertPro", path: "expertPro", component: expertPro },
      { name: "me", path: "me", component: me },
      //   {
      //     name: 'mine',
      //     path: 'mine',
      //     component: mine,
      //     meta: {
      //       needLogin: true
      //     }
      //   }
    ],
  },
];

// const router = new VueRouter({
//   routes
// })
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.query?.t) return next();
  next({ ...to, query: { ...to.query, t: Date.now() } });
});
export default router;
